// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pjimmdpaxokzpuwkrind.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBqaW1tZHBheG9renB1d2tyaW5kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYzNzE0MzIsImV4cCI6MjA3MTk0NzQzMn0.RC9h8TGVl5_EKx0f55x9Rp9RDZ74LMowWJVfiPp-r-c";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});